import { Component, Input } from '@angular/core';
import { Housing, KalpAnswersNO } from '@app/service/leq/leq.service';

@Component({
  selector: 'app-leq-summary-no',
  templateUrl: './leq-summary-no.component.html',
  styleUrls: ['../../route/page-shared.css', './leq-summary-no.component.scss'],
})
export class LeqSummaryNoComponent {
  @Input() kalpAnswers: KalpAnswersNO;

  constructor() {}

  mapTypeOfLivingToReadable(typeOfLiving: Housing): string {
    switch (typeOfLiving) {
      case Housing.RENTAL:
        return 'Utleieleilighet';
      case Housing.CONDO:
        return 'Selveir';
      case Housing.HOUSE:
        return 'Andels- eller aksjeeier';
      default:
        return 'UNKNOWN HOUSING TYPE';
    }
  }

  getNumberOfChildren(): string {
    if (this.kalpAnswers.numberOfChildren >= 5) {
      return '5 eller flere';
    }

    return `${this.kalpAnswers.numberOfChildren || 0} stk`;
  }
}
